import type { AeropayBankConnection } from '@iheartjane/data-access';
import { useCallback } from 'react';
import { useFetcher } from 'react-router';

import type { ActionResult } from '@jane/bloom/types/actions/remixAction';

export function useAeropayBankConnection() {
  const fetcher = useFetcher<ActionResult<AeropayBankConnection>>();

  const fetchBankConnection = useCallback(() => {
    fetcher.load(`/api/bank-connection`);
  }, [fetcher]);

  return {
    data: fetcher.data,
    fetchBankConnection,
    state: fetcher.state,
  };
}
